import { NgModule } from '@angular/core';
import { InputSelectAddonComponent } from './input-select-addon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { SelectAndFieldComponent } from './select-and-field/select-and-field.component';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, ReactiveFormsModule],
  exports: [InputSelectAddonComponent, SelectAndFieldComponent],
  declarations: [InputSelectAddonComponent, SelectAndFieldComponent],
  providers: [],
})
export class InputSelectAddonModule { }
